var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCirclePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "circle-plus_svg__a_".concat(unique),
    d: "M0 20h20V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.934a.6.6 0 01-.6-.6V10.6H6.666a.598.598 0 01-.6-.6.6.6 0 01.601-.6H9.4V6.667a.6.6 0 111.2 0V9.4h2.733a.601.601 0 010 1.2H10.6v2.733c0 .331-.269.6-.6.6zM2 10a8 8 0 008 8 8 8 0 100-16 8 8 0 00-8 8z",
    id: "circle-plus_svg__b_".concat(unique)
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "circle-plus_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#circle-plus_svg__b_".concat(unique)
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#A6A6A6",
    xlinkHref: "#circle-plus_svg__b_".concat(unique)
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#circle-plus_svg__c)",
    d: "M0 0h20v20H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/assets/circle-plus.549e9e72.svg";
export { ForwardRef as ReactComponent };